<template>
  <div class="modify-pwd-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <h3 class="title">修改密码</h3>
      </div>

      <el-form-item prop="oldPassword">
        <div class="label">旧密码</div>
        <el-input v-model="loginForm.oldPassword" type="password" placeholder="旧密码" name="oldPassword" />
      </el-form-item>


      <el-form-item prop="password">
        <div class="label">新密码</div>
        <el-input v-model="loginForm.password" type="password" placeholder="新密码" name="password" />
      </el-form-item>

      <el-form-item prop="confirmPassword">
        <div class="label">确认密码</div>
        <el-input v-model="loginForm.confirmPassword" type="password" placeholder="确认密码" name="confirmPassword" />
      </el-form-item>

      <el-button :disabled="disabledSubmitBtn" :loading="loading" type="primary" @click.native.prevent="doModifyPwd">确认修改</el-button>

    </el-form>
    <code-img :value.sync="codeForm" :visible.sync="codeImgVisible" @submit="doModifyPwd"></code-img>
  </div>
</template>

<script>
import { UserModifyPassword } from "@/api/login";
import codeImg from '@/components/codeImg/index.vue';
import { userLoginError, validStrictPsd, strictPsdError } from '@/utils';

export default {
  name: "modifyPwd",
  components: {
    codeImg,
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码必须是8-16个字符"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!validStrictPsd(value)) {
        callback(new Error(strictPsdError));
      } else {
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (!validStrictPsd(value)) {
        callback(new Error(strictPsdError));
      } else if (value !== this.loginForm.password) {
        callback(new Error("新密码和确认密码必须一致"));
      } else {
        callback();
      }
    };
    return {
      isCountDown: false,
      countDownNumber: 60,
      loginForm: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      loginRules: {
        oldPassword: [{ required: true, trigger: "blur", validator: validateUsername }],
        password: [{ required: true, trigger: "blur", validator: validatePassword }],
        confirmPassword: [{ required: true, trigger: "blur", validator: validateConfirmPassword }],
      },
      loading: false,
      codeForm: {
        code: "",
        sess: "",
      },
      codeImgVisible: false,
    };
  },
  computed: {
    disabledSubmitBtn() {
      return !(
        this.loginForm.oldPassword.length >= 8 && this.loginForm.oldPassword.length <= 16
        && this.loginForm.password.length >= 8
        && this.loginForm.password.length <= 16
        && this.loginForm.password === this.loginForm.confirmPassword
      );
    },
  },
  methods: {
    doModifyPwd() {
      let validResult = true;
      this.$refs.loginForm.validate((valid) => {
        validResult = valid;
        return validResult;
      });
      if (!validResult) {
        return;
      }
      this.loading = true;
      const userName = localStorage.getItem('LOGIN_INFO') && JSON.parse(localStorage.getItem('LOGIN_INFO')).userName;
      const time = new Date().getTime();
      const salt = `YK${time}MS`;
      const psdMd5 = (this.$md5(this.loginForm.oldPassword)).toUpperCase();
      const pass = `${salt}|${this.$md5(psdMd5 + salt)}`;
      const para = {
        name: userName,
        nameType: 1, // 1：用户名  2：手机号
        pass,
        passType: 1, // 1：用户密码  2：验证码
        new: this.$md5(this.loginForm.password).toUpperCase(),
        newType: 1, //  1：修改密码 （手机号对应单用户直接修改密码）
        captcha: this.codeForm.code,
        captchaKey: this.codeForm.sess,
      };
      UserModifyPassword(para).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: "密码修改成功！",
            type: "success",
          });
          this.$router.push({ path: "/login" });
        } else if ([10020, 10022].includes(res.data.code)) {
          // 需要图形验证码，验证码有误
          this.codeImgVisible = false;
        } else {
          const msg = userLoginError(res.data.code);
          this.$message({
            showClose: true,
            message: msg,
            type: 'warning',
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
/* reset element-ui css */
.modify-pwd-container {
  background-color: #f1f1f1;
  .el-input {
    height: 47px;
    text-align: center;
    input {
      background: transparent;
      border: 1px solid #e8eaec;
      -webkit-appearance: none;
      border-radius: 4px;
      padding: 12px 5px 12px 80px;
      height: 47px;
      width: 430px;
      color: #000;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #000 !important;
      }
    }
  }

  .el-form-item {
    .el-form-item__content {
      .label {
        position: absolute;
        height: 47px;
        line-height: 47px;
        padding: 0 20px;
        color: #666666;
        font-size: 14px;
        z-index: 10;
      }
      .count-down {
        line-height: 47px;
        color: #f95d5b;
        width: 110px;
        text-align: center;
      }
    }
    .el-button--success {
      margin-left: 20px;
    }
    &.code {
      .el-form-item__content {
        display: flex;
        .el-input {
          flex: 3;
          input {
            width: 100%;
          }
        }
        .img {
          padding-left: 14px;
          flex: 1;
          height: 50px;
          img {
            height: 100%;
            width: 133px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.modify-pwd-container {
  min-height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .login-form {
    position: absolute;
    border-radius: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 530px;
    height: 450px;
    max-width: 100%;
    background-color: #fff;
    padding: 50px;
    overflow: hidden;
    .el-button--primary {
      background-color: #ffa300;
      border: none;
      width: 100%;
      height: 52px;
      border-radius: 6px;
      margin-bottom: 30px;
      &.is-disabled {
        background-color: #e5e5e5;
        color: #a7a7a7;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #868686;
    text-align: center;
    cursor: pointer;
  }

  .title-container {
    position: relative;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000033;
      margin: 10px auto 30px auto;
      text-align: left;
    }
  }
}
</style>
